var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlumbing = function SvgPlumbing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 92 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.68 10.016H3.013v45.567a.78.78 0 0 0 .779.779H30.563l.118-46.346Z",
    fill: "#647F7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.144 10.016h31.423a.614.614 0 0 0 .542-.331.568.568 0 0 0 .119-.33V.614a.591.591 0 0 0-.213-.473L32.803 0H.884L.67.142a.661.661 0 0 0-.188.472v8.74a.78.78 0 0 0 0 .331.661.661 0 0 0 .566.33M12.29 17.758h-.355a2.88 2.88 0 0 0-2.432 1.323 3.12 3.12 0 0 0-.472 1.653c.025.374.113.742.26 1.087.146.328.355.625.614.874a2.737 2.737 0 0 0 1.96.85.895.895 0 0 0 .353 0H12.998l.33-.165h.189l.448-.354c.139-.14.265-.29.378-.45.21-.322.354-.684.425-1.062a2.358 2.358 0 0 0 0-.567v-.449h8.192v-2.362H12.407",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.484 51.516H12.547v55.417a1.065 1.065 0 0 0 1.062 1.063H52.4a1.084 1.084 0 0 0 1.085-1.063V51.516Z",
    fill: "#647F7F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.249 56.382A35.829 35.829 0 0 1 79.1 82.296a35.788 35.788 0 0 1-25.63 10.816A35.773 35.773 0 0 1 27.84 82.296a35.813 35.813 0 0 1-10.148-25.914v-4.866h71.557v4.866Z",
    fill: "#647F7F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.208 53.742h77.696a.66.66 0 0 0 .66-.661v-3.709a.662.662 0 0 0-.66-.661H13.208a.66.66 0 0 0-.661.661v3.709a.661.661 0 0 0 .66.661Z",
    fill: "#fff"
  })));
};
export default SvgPlumbing;